import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { debounce, Subject, timer } from 'rxjs';

@Component({
  selector: 'app-search-menu-element',
  imports: [IconComponent],
  templateUrl: './search-menu-element.html',
  styleUrl: './search-menu-element.scss',
})
export class SearchMenuElement {
  readonly column: InputSignal<string> = input.required<string>();
  readonly value: InputSignal<string | number | undefined> = input<string | number | undefined>();
  readonly placeholder: InputSignal<string> = input<string>('Rechercher');
  readonly debounceMs: InputSignal<number> = input<number>(400);

  readonly valueChange: OutputEmitterRef<string> = output<string>();

  private readonly valueChanges: Subject<string> = new Subject<string>();

  constructor() {
    this.valueChanges
      .pipe(
        debounce(() => timer(this.debounceMs())),
        takeUntilDestroyed(),
      )
      .subscribe((value: string) => this.valueChange.emit(value));
  }

  setSearchValue(value: string): void {
    this.valueChanges.next(value);
  }
}
